const KEYURI = {

    // BACKEND_URI:"http://localhost:5000/api"

    BACKEND_URI:"https://dolphin-app-zye7a.ondigitalocean.app/api"


}

export default KEYURI


